module.exports = __webpack_public_path__ + "static/img/brandhead.92ceb0a4.png";